import { render, staticRenderFns } from "./gongyingshang.vue?vue&type=template&id=384ebef3&scoped=true"
import script from "./gongyingshang.vue?vue&type=script&lang=js"
export * from "./gongyingshang.vue?vue&type=script&lang=js"
import style0 from "./gongyingshang.vue?vue&type=style&index=0&id=384ebef3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384ebef3",
  null
  
)

export default component.exports